/**
 *
 * ResultsItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import helmetIcon from '../../../../assets/icons/helmet.svg';
import horseIcon from '../../../../assets/icons/horse.svg';
import { LiveFeedEventResult } from '../../../../domain';

interface IProps {
  result: LiveFeedEventResult;
  disabledFields: string[];
  scoreByOptimumTime?: boolean;
}

const ResultsItem: FunctionComponent<IProps> = ({ result, disabledFields }) => {
  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };

  return (
    <tr>
      <td>{isEnabled('eaEventClassAndSort') && result.eaEventClassAndSort}</td>
      <td>{isEnabled('sectionName') && result.sectionName}</td>
      <td>
        {isEnabled('bridleNumber') && (
          <div className="fw-7">{result.bridleNumber}</div>
        )}
      </td>
      <td>
        <div className="d-flex align-items-center">
          <img src={helmetIcon} className="mr-11" alt="" />
          <div className="fs-12 fw-7 text-nowrap">
            {result.riderFirstName} {result.riderLastName}
          </div>
        </div>
      </td>
      <td className="horse-detailed">
        <div className="d-flex align-items-center">
          <img src={horseIcon} className="mr-11" alt="" />
          <div className="d-flex flex-column">
            <div className="fs-12 fw-7 text-nowrap">{result.horseName}</div>
            <div className="fs-12 txt-secondary">
              Owner: {result.ownerFirstName} {result.ownerLastName}
            </div>
          </div>
        </div>
      </td>
      <td>
        {isEnabled('sjFaults') && result.sjFaults}
      </td>
      <td>
        {isEnabled('xcFaults') && result.xcFaults}
      </td>
      <td>
        {isEnabled('totalJFaults') && result.totalJFaults}
      </td>
      <td>
        {isEnabled('evTrialScoringTime') && result.evTrialScoringTime}
      </td>
      <td>
        {isEnabled('evTrialTimePenalties') && result.evTrialTimePenalties}
      </td>
      <td>
        {isEnabled('evTrialTotalScore') && result.evTrialTotalScore}
      </td>
      <td>{isEnabled('sectionPlace') && result.sectionPlace}</td>
      <td>{isEnabled('overallPlace') && result.overallPlace}</td>
      <td>
        {isEnabled('riderClassStatusCode') && (
          <div className="fw-7 fs-12">
            {result.riderClassStatusCode}
          </div>
        )}
      </td>
    </tr>
  );
  // return (
  //   <StyledCard ref={ref} className="mt-10 mb-10">
  //     <div className="card-body">
  //       <div className="row">
  //         <div className="col-2">
  //           {isEnabled('bridleNumber') && (
  //             <>
  //               <div className="fw-7">{result.bridleNumber}</div>
  //               <div className="txt txt-secondary fs-11">Rider/BN</div>
  //             </>
  //           )}
  //         </div>
  //         <div className="col-7">
  //           {isEnabled('eaEventClassAndSort') && (
  //             <>
  //               <div className="txt">{result.eaEventClassAndSort}</div>
  //               <div className="txt txt-secondary fs-11">Class</div>
  //             </>
  //           )}
  //           {isEnabled('sectionName') && (
  //             <>
  //               <div className="txt mt-15">{result.sectionName}</div>
  //               <div className="txt txt-secondary fs-11">Section</div>
  //             </>
  //           )}
  //           <div className="d-flex mt-15">
  //             <img src={helmetIcon} className="mr-11" alt="" />
  //             <div className="fs-12 fw-7">
  //               {result.riderFirstName} {result.riderLastName}
  //             </div>
  //           </div>
  //           <div className="d-flex align-items-center">
  //             <img src={horseIcon} className="mr-11" alt="" />
  //             <div>
  //               <div className="fs-12 fw-7">{result.horseName}</div>
  //               <div className="fs-12">
  //                 Owner: {result.ownerFirstName} {result.ownerLastName}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="col-3 txt-right">
  //           {isEnabled('riderClassStatusCode') && (
  //             <>
  //               <p className="txt fw-7 txt-accent name">
  //                 {result.riderClassStatusCode}
  //               </p>
  //               <p className="txt txt-secondary fs-11">Status</p>
  //             </>
  //           )}
  //           <div className="d-inline-flex flex-column mt-15">
  //             {isEnabled('overallPlace') && (
  //               <Badge>OP {result.overallPlace}</Badge>
  //             )}
  //             {isEnabled('sectionPlace') && (
  //               <Badge className="mt-5">SP {result.sectionPlace}</Badge>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //       <div className="row">
  //         <div className="col-2">
  //           {isEnabled('evTrialScoringTime') && (
  //             <div>
  //               <p className="txt fw-7 mt-15">{result.evTrialScoringTime}</p>
  //               <p className="txt txt-secondary fs-11">Time(secs)</p>
  //             </div>
  //           )}
  //           {isEnabled('evTrialTimePenalties') && (
  //             <div className="mt-15">
  //               <p className="txt fw-7 mt-15">{result.evTrialTimePenalties}</p>
  //               <p className="txt txt-secondary fs-11">Time(pens)</p>
  //             </div>
  //           )}
  //         </div>
  //         <div className="col-5">
  //           {isEnabled('sjPenalties') && (
  //             <div className="mt-15">
  //               <p className="txt fw-7 mt-15">{result.sjPenalties}</p>
  //               <p className="txt txt-secondary fs-11">SJ Penalties</p>
  //             </div>
  //           )}
  //           {isEnabled('xcFaults') && (
  //             <div className="mt-15">
  //               <p className="txt fw-7 mt-15">{result.xcFaults}</p>
  //               <p className="txt txt-secondary fs-11">XC Penalties</p>
  //             </div>
  //           )}
  //         </div>
  //         <div className="col-5">
  //           {isEnabled('totalJFaults') && (
  //             <div className="mt-15">
  //               <p className="txt fw-7 mt-15">{result.totalJFaults}</p>
  //               <p className="txt txt-secondary fs-11">TotalJ Faults</p>
  //             </div>
  //           )}
  //           {isEnabled('evTrialTotalScore') && (
  //             <div className="mt-15">
  //               <p className="txt mt-15 fw-7">{result.evTrialTotalScore}</p>
  //               <p className="txt txt-secondary fs-11">Score</p>
  //             </div>
  //           )}
  //         </div>
  //       </div>
  //     </div>
  //   </StyledCard>
  // );
};

export default memo(ResultsItem);
